import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader,
  MenuItem, Paper, TableFooter
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import { LoadingComponent } from 'src/utils/newLoader';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
  tableContainer: {
    overflowX: 'auto',
    maxWidth: '100%'
  },
  table: {
    minWidth: 650
  },
  totalCell: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
    zIndex: 1000
  },
  subCell: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 900
  }
}));

const screenCode = 'CROPSUPPLYPERIODICALREPORT';

export default function CropSupplyPeriodicalReport(props) {
  const [title, setTitle] = useState("Monthly Crop Supplier Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [cropSupplyInput, setCropSupplyInput] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: ''
  });
  const [cropSupplyDetails, setCropSupplyDetails] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    registrationNumber: "0",
    startDate: '',
    endDate: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const componentRef = useRef();
  const navigate = useNavigate();
  const alert = useAlert();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [columnNames, setColumnNames] = useState([]);
  const options = {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
    setPage(0);
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
    setCropSupplyInput({
      ...cropSupplyInput,
      factoryID: '0',
      routeID: '0',
    });
  }, [cropSupplyInput.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
    setCropSupplyInput({
      ...cropSupplyInput,
      routeID: '0',
    });
  }, [cropSupplyInput.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCROPSUPPLIERPERIODICALREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setCropSupplyInput({
      ...cropSupplyInput,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(cropSupplyInput.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(cropSupplyInput.factoryID);
    setRouteList(routes);
  }

  function getMonthsDifference(start, end) {
    return end.getMonth() - start.getMonth() + (12 * (end.getFullYear() - start.getFullYear())) + 1;
  }

  async function GetDetails() {
    const startObj = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const endObj = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);

    const monthDiff = getMonthsDifference(startObj, endObj);
    if (monthDiff > 12) {
      alert.error("Selected Range Exceeds 1 Year (12 Months) limit");
      return;
    }
    if (startObj > endObj) {
      alert.error("To Month cannot be older than From Month");
      return;
    }

    let model = {
      groupID: parseInt(cropSupplyInput.groupID),
      factoryID: parseInt(cropSupplyInput.factoryID),
      routeID: parseInt(cropSupplyInput.routeID),
      registrationNumber: cropSupplyInput.registrationNumber,
      startDate: moment(startObj).format('YYYY-MM-DD'),
      endDate: moment(endObj).format('YYYY-MM-DD')
    }

    getSelectedDropdownValuesForReport(model);

    const response = await services.GetCropSupplyPeriodicalReportDetails(model);
    if (response.statusCode == "Success" && response.data != null) {
      response.data.forEach(x => {
        let total = 0;
        x.groupList.forEach(y => {
          total += y.cropWeight;
          x.totalAmount = total;
        })
      });

      var cropDetails = await createColumn(startObj, monthDiff);
      createData(response.data, cropDetails);
      setColumnNames(cropDetails);
      setCropSupplyDetails(response.data);
      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(response.message);
    }
  }

  const uniqueDates = [];
  cropSupplyDetails.forEach(row => {
    row.groupList.forEach(item => {
      if (!uniqueDates.includes(item.cropCollectedDate)) {
        uniqueDates.push(item.cropCollectedDate);
      }
    });
  });

  async function createColumn(startDate, iterations) {
    let cropSupplyDetailsArray = [];
    var loopDate = new Date(startDate);
    cropSupplyDetailsArray.push("Route Name");
    cropSupplyDetailsArray.push("Registration Number");
    cropSupplyDetailsArray.push("Customer Name");

    [...Array(iterations)].map((_, i) => {
      cropSupplyDetailsArray.push(moment(loopDate).format('YYYY-MM-DD'));
      loopDate.setMonth(loopDate.getMonth() + 1);
    });

    cropSupplyDetailsArray.push("Total");
    return cropSupplyDetailsArray;
  }

  async function createFile() {
    var file = [];
    var totalColumn = {};
    var totalRow = {};

    for (const obj of cropSupplyDetails) {
      let tModel = {
        'Route Name': obj.routeName,
        'Registration Number': obj.registrationNumber,
        'Customer Name': obj.name
      };

      let indexCount = 1;
      let availableMonthDates = Object.keys(columnNames).map(k => columnNames[k]).filter(x => x !== 'Route Name' && x !== 'Registration Number' && x !== 'Customer Name' && x !== 'Total');

      for (const colDate of availableMonthDates) {
        let monthKey = "Month " + indexCount.toString().padStart(2, '0');
        indexCount++;

        let foundDate = obj.groupList.find(x => x.cropCollectedDate.split("T")[0] === colDate);
        let weight = foundDate ? parseFloat(foundDate.cropWeight) : 0;

        tModel[monthKey] = weight > 0 ? weight : 0;
        totalColumn[monthKey] = parseFloat((totalColumn[monthKey] || 0) + weight);
      }
      file.push(tModel);
    }

    Object.keys(totalColumn).forEach(key => {
      totalRow[key] = totalColumn[key];
    });

    file.forEach(row => {
      let total = 0;
      for (const key in row) {
        if (key !== 'Route Name' && key !== 'Registration Number' && key !== 'Customer Name') {
          total += parseFloat(row[key]) || 0;
        }
      }
      row['Total'] = total;
    });

    let totalSum = 0;
    file.forEach(row => {
      totalSum += row['Total'] || 0;
    });
    totalRow['Total'] = totalSum;

    file.push({
      'Route Name': 'Total',
      'Registration Number': '',
      'Customer Name': '',
      ...totalRow
    });

    file.push({});
    let filterData = {
      'Route Name': 'Group: ' + selectedSearchValues.groupName,
      'Registration Number': 'Factory: ' + selectedSearchValues.factoryName
    }
    file.push(filterData);

    let filterDate = {
      'Route Name': 'From Month: ' + selectedSearchValues.startDate,
      'Registration Number': 'To Month: ' + selectedSearchValues.endDate,
    }
    file.push(filterDate);

    var settings = {
      sheetName: ('Crop Supply Periodical').substring(0, 30),
      fileName: 'Monthly Crop Supplier Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + selectedSearchValues.startDate + ' - ' + selectedSearchValues.endDate,
      writeOptions: {}
    };

    let tempcsvHeaders = [];
    tempcsvHeaders.push({ label: 'Route', value: 'Route Name' });
    tempcsvHeaders.push({ label: 'RegistrationNo', value: 'Registration Number' });
    tempcsvHeaders.push({ label: 'Name', value: 'Customer Name' });

    let availableMonthDates = columnNames.filter(x => x !== 'Route Name' && x !== 'Registration Number' && x !== 'Customer Name' && x !== 'Total');

    let indexCount = 1;
    for (const colDate of availableMonthDates) {
      tempcsvHeaders.push({ label: 'Month ' + indexCount.toString().padStart(2, '0'), value: 'Month ' + indexCount.toString().padStart(2, '0') });
      indexCount++;
    }

    tempcsvHeaders.push({ label: 'Total', value: 'Total' });

    let dataA = [
      {
        sheet: 'Crop Supply Periodical Repor',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  async function createData(data, columnNames) {
    var res = [];
    if (columnNames != null) {
      data.forEach(x => {
        var dataRow = []
        dataRow.push(x.routeName);
        dataRow.push(x.registrationNumber);
        dataRow.push(x.name);

        columnNames.forEach(item => {
          if (item !== 'Route Name' && item !== 'Registration Number' && item !== 'Customer Name' && item !== 'Total') {
            var object = _.find(x.groupList, o => o.cropCollectedDate.split("T")[0] === item);
            var value = object ? object.cropWeight : 0;
            dataRow.push(value);
          }
        });

        res.push(dataRow);
      });
    }
    return res;
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setCropSupplyInput({
      ...cropSupplyInput,
      [e.target.name]: value
    });
    setCropSupplyDetails([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: searchForm.routeID == 0 ? "All Routes" : routeList[searchForm.routeID],
      registrationNumber: searchForm.registrationNumber === '' ? "All" : [searchForm.registrationNumber],
      startDate: moment(startDate).format("MMM-YYYY"),
      endDate: moment(endDate).format("MMM-YYYY"),
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: cropSupplyInput.groupID,
              factoryID: cropSupplyInput.factoryID,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={cropSupplyInput.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                              size='small'
                            >
                            </TextField>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="From Month"
                                helperText="Select from month *"
                                value={startDate}
                                onChange={(e) => {
                                  setStartDate(e);
                                  // Automatically adjust end date if needed
                                  var diff = getMonthsDifference(new Date(e.getFullYear(), e.getMonth(), 1), new Date(endDate.getFullYear(), endDate.getMonth(), 1));
                                  if (diff < 1 || diff > 12) {
                                    let newEndDate = new Date(e.getFullYear(), e.getMonth() + 11, 1);
                                    if (newEndDate > new Date()) newEndDate = new Date();
                                    setEndDate(newEndDate);
                                  }
                                  setCropSupplyDetails([]);
                                }}
                                size='small'
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="To Month"
                                helperText="Select to month *"
                                value={endDate}
                                maxDate={new Date()}
                                onChange={(e) => {
                                  setEndDate(e);
                                  setCropSupplyDetails([]);
                                }}
                                size='small'
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>

                        <Box minWidth={1050} hidden={cropSupplyDetails.length === 0}>
                          <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
                            <Table size="small" aria-label="sticky table" Table stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "16px" }} align="left">
                                    Route
                                  </TableCell>
                                  <TableCell style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "16px" }} align="left">
                                    Reg.No
                                  </TableCell>
                                  <TableCell style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "16px" }} align="left">
                                    Customer
                                  </TableCell>
                                  {columnNames.filter(x => x !== 'Route Name' && x !== 'Registration Number' && x !== 'Customer Name' && x !== 'Total').map((row, index) => (
                                    <TableCell key={index} className={`${classes.stickyHeader} ${classes.stickyColumn}`} style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "16px" }} align="center">
                                      Month {(index + 1).toString().padStart(2, '0')}
                                    </TableCell>
                                  ))}
                                  <TableCell style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "16px" }} align="center">Total </TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {cropSupplyDetails.slice(page * limit, page * limit + limit).map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell style={{ border: "1px solid #ccc", fontSize: "15px" }} align="left" component="th" scope="row">
                                      {row.routeName}
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid #ccc", fontSize: "15px" }} align="left" component="th" scope="row">
                                      {row.registrationNumber}
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid #ccc", fontSize: "15px" }} align="left" component="th" scope="row">
                                      {row.name}
                                    </TableCell>
                                    {columnNames.filter(x => x !== 'Route Name' && x !== 'Registration Number' && x !== 'Customer Name' && x !== 'Total').map((rows, dIndex) => {
                                      var found = row.groupList.find(x => x.cropCollectedDate.split("T")[0] == rows);
                                      return (
                                        <TableCell key={dIndex} style={{ border: "1px solid #ccc" }} align="right">
                                          {found === undefined ? '-' : (found.cropWeight === 0 ? '-' : found.cropWeight.toLocaleString('en-US', options))}
                                        </TableCell>
                                      );
                                    })}
                                    <TableCell style={{ border: "1px solid #ccc", fontWeight: "bold" }} align="right" component="th" scope="row">
                                      {(row.totalAmount).toLocaleString('en-US', options)}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableFooter>
                                <TableRow>
                                  <TableCell className={classes.totalCell} colSpan={3} style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "16px" }} align="left">
                                    Total
                                  </TableCell>
                                  {columnNames.filter(x => x !== 'Route Name' && x !== 'Registration Number' && x !== 'Customer Name' && x !== 'Total').map((day, index) => {
                                    const dayTotal = cropSupplyDetails.reduce((total, row) => {
                                      const found = row.groupList.find(x => x.cropCollectedDate.split("T")[0] === day);
                                      return total + (found ? parseFloat(found.cropWeight) : 0);
                                    }, 0).toLocaleString('en-US', options);

                                    return (
                                      <TableCell className={classes.subCell} style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "14px" }} align="right" key={index}>
                                        {dayTotal !== 0 ? dayTotal.toLocaleString('en-US', options) : '-'}
                                      </TableCell>
                                    );
                                  })}
                                  <TableCell className={classes.subCell} style={{ border: "1px solid #ccc", fontWeight: "bold", fontSize: "14px", }} align="right">
                                    {cropSupplyDetails.reduce((total, row) => total + parseFloat(row.totalAmount), 0).toLocaleString('en-US', options)}
                                  </TableCell>
                                </TableRow>
                              </TableFooter>
                            </Table>
                            <TablePagination
                              component="div"
                              count={cropSupplyDetails.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                        </Box>
                      </CardContent>

                      {cropSupplyDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size='small'
                          >
                            EXCEL
                          </Button>

                          {<ReactToPrint
                            documentTitle={'Monthly Crop Supplier Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + selectedSearchValues.startDate + ' - ' + selectedSearchValues.endDate}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />}
                          {<div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              selectedSearchValues={selectedSearchValues}
                              cropSupplyDetails={cropSupplyDetails}
                              columnNames={columnNames}
                            />
                          </div>}

                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
